import startCase from 'lodash/startCase'
import forOwn from 'lodash/forOwn'

const humanizeError = (field, value) => {
  return `${startCase(field)}: ${value}`
}

export const humanizeErrors = (error) => {
  let errors = []
  forOwn(error, (values, field) => {
    if (typeof values == 'string') {
      errors.push(humanizeError(field, values))
    } else {
      for (let value of values) {
        errors.push(humanizeError(field, value))
      }
    }
  })
  return errors
}
